import type { Filter } from '@/app/common/filters/core/filtersTypes.ts';
import { isOptionSelected } from '@/app/common/filters/core/filterOptionSelection.ts';
import { chipBehaviourOf } from '@/app/common/filters/types/filterTypeBehaviour.ts';

export const isQuickFilterApplied = (filter: Filter, values: string[]): boolean => {
  const options = chipBehaviourOf(filter)?.options(filter) ?? [];

  return (
    values.length > 0 &&
    values.every((value) => {
      const option = options.find((candidate) => candidate.value === value);
      return !!option && isOptionSelected(option);
    })
  );
};
